<template>
  <component :is="noModal ? 'div' : 'modal'" title="Item Info">
    <div v-if="!noTitle" class="mt-2 mb-3">{{ item.description }}</div>

    <modal-row is-text :l-cols="3" label="Dims">
      {{ item.dim_length || '?' }}" x {{ item.dim_width || '?' }}"
      x {{ item.dim_height || '?' }}" {{ item.weight || '?' }} Lbs
    </modal-row>

    <modal-row :l-cols="3" is-text v-if="item.manuf" @click="clipboard(item.modelno)" label="SKU">
      <b-link target="_blank" :href="'/item/' + item.id">{{ item.gli }}</b-link>
    </modal-row>

    <modal-row :l-cols="3" is-text v-if="item.manuf" @click="clipboard(item.modelno)" label="Manuf">{{
        item.manuf
      }}
    </modal-row>

    <modal-row :l-cols="3" is-text label="Model" v-if="item.modelno" @click="clipboard(item.modelno)">
      <div class="d-flex">
        <div class="flex-fill">
          {{ item.modelno }}
        </div>
        <div>
          <research-menu large :value="(item.manuf || '') + ' ' + (item.modelno || '')" v-b-tooltip.hover title="Research Model Number"/>
        </div>
      </div>
    </modal-row>

    <modal-row :l-cols="3" is-text label="Part" v-if="item.partno" @click="clipboard(item.partno)">
      <div class="d-flex">
        <div class="flex-fill">
          {{ item.partno }}
        </div>
        <div>
          <research-menu large :value="(item.manuf || '') + ' ' + (item.partno || '')"  v-b-tooltip.hover title="Research Part Number"/>
        </div>
      </div>
    </modal-row>
  </component>
</template>

<script>

import ResearchMenu from "@/components/layout/research-menu.vue";

export default {
  name: "auction-research",
  components: {ResearchMenu},
  props: {
    item: Object,
    noModal: Boolean,
    rightHalf: Boolean,
    noTitle: Boolean
  },
  methods: {
    clipboard(txt) {
      navigator.clipboard.writeText(txt).then(() => this.toast('Copied to clipboard.'))
    },
  }
}
</script>

<style scoped>

</style>